export const AI_CHAT_ASSETS_PROMPT_BOX_ID = 'ai-chat-assets-prompt-box';
